export const drugMonitoring = [
  { id: '1000', description: 'Phenobarbital (One Sample)' },
];
